import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import CommunityDevelopmentRevitalizationDetails from '../../subdepartmentdetails/CommunityDevelopmentRevitalization'


function CommunityDevelopmentRevitalization() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Community Development and Revitalization || Housing and Community Development";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Housing"
            title="Community Development Revitalization"
            subtitledown="Department of Housing & Community Development"
           />
            <CommunityDevelopmentRevitalizationDetails/>
        </div>
    </>
  )
}

export default CommunityDevelopmentRevitalization